<template>
  <div class="wrapper-traceability-map">
    <traceability-maps
      v-if="batch"
      :current-status="batch.currentStatus"
      :o-s-alvaro="batch.codeOS || batch.barcode"
      :locations="mapLocations"
      :laboratory="{ name: batch.laboratory.name, address: batch.laboratory.address }"
      :nto="{
        name: `NTO ${ntoName}`,
        address: batch.nto.address,
      }"
      :current-location="{
        address: batch.lotLocation.address,
        position: {
          lat: Number(batch.lotLocation.latitude),
          lng: Number(batch.lotLocation.longitude),
        },
      }"
      :button-label="'VER AMOSTRAS'"
      :button-action="() => goToAmostras()"
      :update-map-in-minutes="updatedAtInMinutes"
    />
    <div v-else>Selecione um lote</div>
  </div>
</template>

<script>
import TraceabilityMaps from '../../common/TraceabilityMaps.vue'

export default {
  name: 'TraceabilityMap',
  components: {
    'traceability-maps': TraceabilityMaps,
  },
  props: {
    batch: { type: Object, default: null },
    ntoName: { type: String, default: '' },
  },
  data() {
    return {
      updatedAtInMinutes: 0,
    }
  },
  computed: {
    mapLocations() {
      console.log('batch no mapLocations', this.batch)
      if (!this.batch) return []
      const b = this.batch
      return [
        {
          name: 'laboratory',
          icon:
            b.laboratory?.icon ||
            'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-lab.png',
          position: {
            lat: Number(b.laboratory.latitude),
            lng: Number(b.laboratory.longitude),
          },
        },
        {
          name: 'transport',
          icon: 'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-in-transit.png',
          position: {
            lat: Number(b.lotLocation.latitude),
            lng: Number(b.lotLocation.longitude),
          },
        },
        {
          name: 'placeExecution',
          icon:
            b.nto?.icon ||
            'https://storageapoiob2bprd.blob.core.windows.net/front-images/icon-alvaro.png',
          position: { lat: Number(b.nto.latitude), lng: Number(b.nto.longitude) },
        },
      ]
    },
  },
  mounted() {
    setInterval(() => {
      this.updatedAtInMinutes += 1
    }, 60000)

    this.updatedAtInMinutes = 0
  },
  methods: {
    goToAmostras(){
      return this.goTo(`/traceability/search?q=${this.batch.lotId}&typeOfSearch=BA`);
    },
    goTo(path) {
      if (this.$route.path !== path) this.$router.push({ path })
    },
    formatAddress(addr = {}) {
      return [addr.street, addr.neighborhood, addr.city, addr.state]
        .filter(Boolean)
        .join(', ')
    },
  },
}
</script>

<style scoped lang="scss">
.wrapper-traceability-map {
  width: 100%;
  flex: 1;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 1rem;
  height: fit-content;
}
</style>
